import { API_URL } from "../../config/endpoints";

export interface RentalAgreement {
  contractUid: string;
  name: string;
  documentHash: string;
  consentText: string;
  canSign: boolean;
  signature: {
    signerName: string;
    signedAt: string;
    signatureImage: string;
    consentText: string;
  } | null;
}

export class AgreementError extends Error {
  constructor(message: string, public status: number) {
    super(message);
  }
}

export async function agreementRequest(
  uid: string,
  path = "",
  input?: unknown
): Promise<Response> {
  const response = await fetch(
    `${API_URL}/guest/reservations/${encodeURIComponent(
      uid
    )}/rental-agreement${path}`,
    {
      method: input === undefined ? "GET" : "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        ...(input === undefined ? {} : { "Content-Type": "application/json" }),
      },
      ...(input === undefined ? {} : { body: JSON.stringify(input) }),
      cache: "no-store",
    }
  );
  if (!response.ok) {
    throw new AgreementError(
      response.status === 409
        ? "The agreement changed or was already signed. Reopen it to review the latest version."
        : response.status === 401
        ? "Your session expired. Please sign in again."
        : response.status === 429
        ? "Too many attempts. Please wait a minute and try again."
        : "Unable to load or save the rental agreement. Please try again.",
      response.status
    );
  }
  return response;
}

export async function documentDigest(bytes: ArrayBuffer): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest), (byte) =>
    byte.toString(16).padStart(2, "0")
  ).join("");
}
